// User logs in with Google but no corresponding user doc found in Firestore.
export const reduxGoogleUserNotInFirestore = 'Firebase Auth user does not have a corresponding user doc in Firestore.';
